import { Pipe, PipeTransform } from '@angular/core';
import { formatDateRange } from '../utils/date.utils';

@Pipe({
  name: 'dateRange',
  standalone: true
})
export class DateRangePipe implements PipeTransform {
  transform(startDate?: string, endDate?: string): string {
    return formatDateRange(startDate, endDate);
  }
}
